<ion-content class="ion-no-padding">
  <div class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">
          <span>Add Hotel</span>
        </ion-title>

        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" (click)="onSubmit(true)" [disabled]="!formDataModified()">Save &
            New</ion-button>

          <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit()"
            [disabled]="!formDataModified()">Save</ion-button>

          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>

      <div class="form-container">
        <form [formGroup]="hotelPricingForm" *ngIf="hotelPricingForm">
          <div class="invoice-form-container">
            <!-- ================= HOTEL DETAILS ================= -->
            <div>
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
                Hotel Details
              </ion-title>
            </div>
            <div class="form-containesr ion-padding-horizontal toggle-visibility" formGroupName="hotelDetails">
              <!-- hotels row -->
              <div class="row">
                <div class="col-3">
                  <div class="input-container">
                    <label for="state" class="label">Location *</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.location')?.invalid && hotelPricingForm.get('hotelDetails.location')?.touched }">
                      <app-locations-autocomplete formControlName="location"></app-locations-autocomplete>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Hotel Name*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.hotelName')?.invalid && hotelPricingForm.get('hotelDetails.hotelName')?.touched }">
                      <input class="input-text input" type="text" placeholder="Enter Hotel Name"
                        formControlName="hotelName">
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Hotel Category*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.hotelCategory')?.invalid && hotelPricingForm.get('hotelDetails.hotelCategory')?.touched }">
                      <select class="input" formControlName="hotelCategory">
                        <option value="" hidden>select</option>
                        <option *ngFor="let item of accommodationType" [value]="item.name">
                          {{item.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for class="label">Hotel Website</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.hotelWebsite')?.invalid && hotelPricingForm.get('hotelDetails.hotelWebsite')?.touched }">
                      <input type="text" class="input" placeholder="www.yourdomain.com"
                        formControlName="hotelWebsite" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- address fields -->
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Address Line 1 *</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.address1')?.invalid && hotelPricingForm.get('hotelDetails.address1')?.touched }">
                      <input type="text" class="input input-text" placeholder="Address1" formControlName="address1" />
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Address Line 2</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.address2')?.invalid && hotelPricingForm.get('hotelDetails.address2')?.touched }">
                      <input type="text" class="input input-text" placeholder="Address2" formControlName="address2" />
                    </div>
                  </div>
                </div>

              </div>

              <!-- address details -->
              <div class="row">
                <div class="col-12">
                  <app-address-fields formControlName="groupedAddress"></app-address-fields>
                </div>
              </div>

              <!-- names -->
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">First Name*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.firstName')?.invalid && hotelPricingForm.get('hotelDetails.firstName')?.touched }">
                      <input class="input" type="text" placeholder="First Name" formControlName="firstName">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Last Name</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.lastName')?.invalid && hotelPricingForm.get('hotelDetails.lastName')?.touched }">
                      <input class="input" type="text" placeholder="Last Name" formControlName="lastName">
                    </div>
                  </div>
                </div>
              </div>

              <!-- email and number -->
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Contact Phone Number</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.phoneNumber')?.invalid && hotelPricingForm.get('hotelDetails.phoneNumber')?.touched }">
                      <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for class="label">Contact Email*</label>
                    <div
                      [ngClass]="{ 'invalid-input': hotelPricingForm.get('hotelDetails.contactEmail')?.invalid && hotelPricingForm.get('hotelDetails.contactEmail')?.touched }">
                      <input class="input input-text" placeholder="Email Address" formControlName="contactEmail" />
                    </div>
                  </div>
                </div>

                <!-- Facilities -->
                <div class="col-6 date-time-width">
                  <div class="input-container">
                    <label class="label">Facilities</label>
                    <div>
                      <app-multi-select-custom-input-dropdown [dropdownItems]="facilitiesOptions"
                        formControlName="facilities"></app-multi-select-custom-input-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <!-- ================= SEASONS ================= -->
            <div>
              <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
                <ion-title class="dark-title-sm ion-no-padding">
                  Seasons
                </ion-title>
              </div>
            </div>
            <div class="form-container ion-padding-horizontal mt-2">
              <div formArrayName="seasons">
                <table class="table table-bordered invoice-items-table">
                  <thead>
                    <tr>
                      <th class="sm-column">S.no</th>
                      <th>Season Title*</th>
                      <th>Start Date*</th>
                      <th>End Date*</th>
                      <th class="sm-column"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let season of seasons.controls; let i = index" [formGroupName]="i">
                      <td class="p-1">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <input formControlName="title" class="table-input" [appMaxLength]="50">
                      </td>
                      <td>
                        <app-date-picker formControlName="startDate" class="table-input"></app-date-picker>
                      </td>
                      <td>
                        <app-date-picker formControlName="endDate" class="table-input"></app-date-picker>
                      </td>
                      <td>
                        <div class="table-actions">
                          <ion-button (click)="removeSeason(i)" [disabled]="seasons.controls.length === 1" fill="clear"
                            color="danger" class="action-btn">
                            <ion-icon name="trash-outline"></ion-icon>
                          </ion-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-end mt-1">
                <ion-button class="unfilled-blue-btn btn-sm" fill="clear" (click)="addSeason()">
                  <ion-icon name="add-outline"></ion-icon>
                  Season
                </ion-button>
              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <!-- ================= ROOM DETAILS AND PRICING ================= -->
            <div>
              <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
                <ion-title class="dark-title-sm ion-no-padding">
                  Room Details And Pricing
                </ion-title>
                <div>
                  <div class="currency-container">
                    <label class="label">
                      Currency
                      <select class="input" formControlName="currency">
                        <option *ngFor="let item of currencyLov" [value]="item.key">
                          {{item.name}}
                        </option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Calculation settings -->
            <div class="form-container ion-padding-horizontal" formGroupName="calculationSettings">
              <div class="row align-items-center">
                <div class="col-4">
                  <div class="input-container">
                    <label class="label">
                      Enable auto calculation
                    </label>
                    <div>
                      <ion-toggle formControlName="autoCalculationEnabled">
                      </ion-toggle>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-container">
                    <label class="label">
                      MAP margin
                    </label>
                    <input type="text" class="input" placeholder="MAP" formControlName="mapDifference">
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-container">
                    <label class="label">
                      AP margin
                    </label>
                    <input type="text" class="input" placeholder="MAP" formControlName="apDifference">
                  </div>
                </div>
              </div>
            </div>
            <!-- Rooms -->
            <div class="form-container ion-padding-horizontal" formArrayName="rooms">
              <div class="room-container mb-2" *ngFor="let room of rooms.controls; let roomIndex = index" [formGroupName]="roomIndex">
                <!-- Room header -->
                <div class="row align-items-end">
                  <div class="col-4">
                    <div class="input-container">
                      <label class="label">
                        Room Category*
                      </label>
                      <div
                        [ngClass]="{ 'invalid-input': room.get('roomCategory')?.invalid && room.get('roomCategory')?.touched }">
                        <app-dropdown-select [dropdownValues]="roomCategory"
                                formControlName="roomCategory"></app-dropdown-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="input-container">
                      <label class="label">
                        Base Occupancy*
                      </label>
                      <app-increment-number-input formControlName="baseOccupancy"></app-increment-number-input>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="input-container">
                      <label class="label">
                        Extra Base Occupancy
                      </label>
                      <app-increment-number-input formControlName="extraBaseOccupancy"></app-increment-number-input>
                    </div>
                  </div>
                  <div class="col-1 d-flex justify-content-end">
                    <ion-button fill="clear" color="danger" class="action-btn" (click)="removeRoom(roomIndex)"
                      [disabled]="rooms.controls.length === 1">
                      <ion-icon name="trash-outline"></ion-icon>
                    </ion-button>
                  </div>
                </div>

                <!-- Pricing -->
                <div class="mt-2" formArrayName="pricing">
                  <div class="mb-3" *ngFor="let pricing of getRoomPricing(roomIndex).controls; let pricingIndex = index"
                    [formGroupName]="pricingIndex">
                    <div class="dark-title-sm mb-1">
                      {{ getSeasonTitle(pricing.get('seasonIndex')?.value) }} Pricing
                    </div>
                    <table class="table table-bordered invoice-items-table">
                      <thead>
                        <tr>
                          <th>
                          </th>
                          <th>
                            Base Rate
                          </th>
                          <th>
                            AWEB
                          </th>
                          <th>
                            CWEB
                          </th>
                          <th>
                            CNB
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- EP -->
                        <tr formGroupName="ep">
                          <th class="p-1">
                            EP
                          </th>
                          <td>
                            <input type="number" class="table-input" formControlName="baseRate">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="aweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cnb">
                          </td>
                        </tr>
                        <!-- CP -->
                        <tr formGroupName="cp">
                          <th class="p-1">
                            CP
                          </th>
                          <td>
                            <input type="number" class="table-input" formControlName="baseRate">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="aweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cnb">
                          </td>
                        </tr>
                        <!-- MAP -->
                        <tr formGroupName="map">
                          <th class="p-1">
                            MAP
                          </th>
                          <td>
                            <input type="number" class="table-input" formControlName="baseRate">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="aweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cnb">
                          </td>
                        </tr>
                        <!-- AP -->
                        <tr formGroupName="ap">
                          <th class="p-1">
                            AP
                          </th>
                          <td>
                            <input type="number" class="table-input" formControlName="baseRate">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="aweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cweb">
                          </td>
                          <td>
                            <input type="number" class="table-input" formControlName="cnb">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- Add Room -->
              <div class="d-flex justify-content-end mt-2">
                <ion-button class="unfilled-blue-btn btn-sm" fill="clear" (click)="addRoom()">
                  <ion-icon name="add-outline"></ion-icon>
                  Room
                </ion-button>
              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <!-- ================= NOTES ================= -->
            <div class="itinerary-model-content">
              <div class="ion-no-padding mb-1">
                <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
                  Notes
                </ion-title>
              </div>
              <div class="form-container ion-padding-horizontal">
                <div class="row">
                  <div class="col">
                    <div class="input-container">
                      <app-text-formatting-input formControlName="notes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dashed-line"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ion-content>